export async function validateCapcha(captcha_key) {
    if (!captcha_key) {
        return true;
    }

    return new Promise((resolve) => {
        grecaptcha.ready(()=> {
            grecaptcha.execute(captcha_key, {action: 'submit'})
            .then((token) => {
                resolve(token);
            });
        });
    });
}